<template>
    <v-page-data-table
            title="公章管理"
            key-name="id"
            :fields="fields"
            ref="seal"
            @create="onDetail"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="SEAL_DELETE"
            query-api="SEAL_QUERY">

        <template v-slot:name="{item}">
            <v-link-text :text="item.name" @click="onDetail(item)"></v-link-text>
        </template>
        <template v-slot:imageUrl="{item}">
            <v-container>
                <v-img class="pointer" @click="viewImage(item.imageUrl)" :max-height="150" :max-width="150" contain
                       v-if="item.imageUrl"
                       :src="item.imageUrl"></v-img>
            </v-container>
        </template>
    </v-page-data-table>
</template>

<script>
    import SealQueryFields from "./fields/SealQueryFields";

    export default {
        name: "SealQuery",
        data() {
            return {
                fields: SealQueryFields,
                html: null,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建公章',
                        color: 'primary',
                        icon: "mdi-plus-circle",
                        action: 'create'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("sealDetail", {id: id});
                // console.log();
            },
            viewImage(url) {
                window.open(url, '_blank');
            }
        }
    }
</script>
